import React, { use, useEffect, useState } from 'react'
import PageContainer from './Pagecontainer'
import ScheduleDemo from './demo'
import { Card, Grid, Typography, Button, Slider, TextField, Box, Alert, Divider, Dialog, FormControlLabel, Checkbox, MenuItem, DialogTitle, DialogContent, DialogActions, FormControl, DialogContentText, IconButton } from '@mui/material'
// import CircularSlider from '@fseehawer/react-circular-slider'
import CircularSlider from "react-circular-slider-svg"
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { IconAlertTriangle, IconArrowLeft, IconArrowRight, IconBolt, IconBoltFilled, IconBook, IconBrain, IconBuilding, IconCheck, IconCloudDown, IconDiamond, IconFilePercent, IconHeartHandshake, IconLink, IconLock, IconTargetArrow, IconTrash, IconX } from '@tabler/icons-react'
import { set, useForm } from 'react-hook-form'
import dayjs from "dayjs";
import Cookies from 'js-cookie'
import { LocalOfferOutlined } from '@mui/icons-material'
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const NewPricing = () => {
    const [plans, setPlans] = useState([]);
    const [reportCount, setReportCount] = useState(1);
    const [lable, setlable] = useState(1);
    const [selectedCard, setSelectedCard] = useState(6);
    const [buyingCard, setBuyingCard] = useState(null);
    const [loading, setLoading] = useState(true);
    const [customPlan, setCustomPlan] = useState(null);
    const [CurrentPlan, setCurrentPlan] = useState(null);
    const userInfo = JSON.parse(Cookies.get("user-info"));
    const currentPlanId = CurrentPlan?.[0]?.id
    const navigate = useNavigate();
    const [Contactpopup, setContactpopup] = useState(false)
    const [successpopup, setsuccesspopup] = useState(false)
    const { register, handleSubmit, formState: { errors }, trigger ,reset,setValue} = useForm();
    const [AlretPopUp,setAlretPopUp]= useState(false)
    const [opencupon,setopencupon]= useState(false)
    const [couponCode, setCouponCode] = useState("");
    const [couponCodeErr, setCouponCodeErr] = useState("");
    const [messageColor, setMessageColor] = useState("#f50000"); 
    const [showapplybutton,setshowapplybutton]= useState(true)
    const [discountedPrice,setdiscountedPrice]= useState(null)
    const [isZeroPlan,setisZeroPlan]= useState(false)
    const [confirmPurchasePopup,setconfirmPurchasePopup]= useState(false)
    const [zeroPlanLoading, setZeroPlanLoading] = useState(false)
    const [zeroPlanSuccess, setZeroPlanSuccess] = useState(false)
    const [zeroPlanError, setZeroPlanError] = useState(false)
    const [zeroPlanErrorMessage, setZeroPlanErrorMessage] = useState("")
    const [successPopup,setSuccessPopup]= useState(false)
    const handleApplyCoupon = async () => {
        if (couponCode.trim() === "") {
            setCouponCodeErr("Please enter a coupon code.");
            return;
        }
       const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const req = {
                promo_code: couponCode,
                user_id: userInfo.id,
                plan_id: customPlan ? customPlan.id : null,
                is_custom: IsCustom,
            }
            try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/customer-promo-codes/`, req,config2);
            if (response.status === 200) {
                // setMessageColor("#4BB543"); 
                // setCouponCodeErr("Coupon code applied successfully!");
                setshowapplybutton(false)
                setdiscountedPrice(response.data?.data);
                response.data?.data.is_billing === false ? setisZeroPlan(true) : setisZeroPlan(false);
                setSuccessPopup(true)
            }
        } catch (error) {
            setCouponCodeErr(error.response?.data.message);
            setMessageColor("#f50000"); 
        }
    };

    console.log(isZeroPlan,'isZeroPlan');


    // const handleConfirmPayment = async () => {
    //         setLoader(true);
    //         setAlretPopUp(false);
    
    //         try {
    //             const config2 = {
    //                 headers: {
    //                     Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
    //                 },
    //             };
    //             const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/buy-subscription/`, formData, config2);
    
    //             if (response.status === 200) {
    //                 setLoader(false);
    //                 getInvoiceData(response.data?.subscription_id);
    //             }
    //         } catch (e) {
    //             console.log(e);
    //             setLoader(false);
    //             setErrorpopup(true);
    //             setErrorMessage(e?.response?.data?.message);
    //         }
    //     };
    
    const handleZeroPlan = async () => {
      try {
        setZeroPlanLoading(true);
        setconfirmPurchasePopup(false);
                const config2 = {
                    headers: {
                        Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
                    },
                };
          const payload = {
              user_id: userInfo?.id,
              selected_plan_id: buyingCard?.id,
              is_custom: IsCustom,
              project_count: reportCount,
              ...(currentPlanId && { current_subscription_id: currentPlanId }),
              customer_payment_profile_id: null,
              coupon_code: couponCode ? couponCode : null,
              ...(couponCode && { is_promocode: true }),
          };
                const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/buy-subscriptionV2/`, payload, config2);
    
                if (response.status === 200) {
                    setZeroPlanLoading(false);
                    setZeroPlanSuccess(true);
                }
            } catch (e) {
                console.log(e);
                setZeroPlanLoading(false);
                setZeroPlanError(true);
                setZeroPlanErrorMessage(e?.response?.data?.message || "Something went wrong. Please try again.");
            }
    };
    const onSubmit = async(data) => {
        console.log(data);
        setLoading(true)
        try{
            let req = { 
                email: data.email,
                phone: data.mobileNumber,
                company_name: data.companyName,
                full_name: data.fullName,
                no_of_ideas: data.numBusinessIdeas,
            }
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
            }
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/contact-us/`, req, config2);
            if (response.status === 201) {
                setContactpopup(false);
                setLoading(false);
                setsuccesspopup(true)
                reset();
            }
        } catch (error) {
            setLoading(false);
            console.error("Error submitting form:", error);
        }
    };
    const GetPlans = async () => {
        setLoading(true);
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-subscription-web/?user_id=${userInfo.id}`, config2);
            if (response.status === 200) {
                setLoading(false);
                setPlans(response.data.plans);
                if (response.data.plans.length > 0) {
                    // Select plan with id 6 initially
                    const plan6 = response.data.plans.find(plan => plan.id === 6);
                    if (plan6) {
                        setReportCount(plan6.no_of_projects_allowed);
                        setBuyingCard(plan6);
                        setTimeout(() => {
                            setCouponCode("ITSERVE2025")
                        }, 100);
                        
                    }
                }
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
            setLoading(false);
        }
    };
 const [CustomPlanError,setCustomPlanError]= useState(null);
    const getCustomPlan = async () => {
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-plan-custom/?project_count=${reportCount}`, config2);
            if (response.status === 200) {
                setCustomPlan(response.data);
                setLoading(false);
                setCustomPlanError(null);
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
            setLoading(false);
            setCustomPlan(null);
            setCustomPlanError(err?.response?.data?.detail || "Failed to fetch custom plan");
        }
    }
    const getCurrentPlan = async () => {
        try {
            setLoading(true)
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`, 'content-type': 'multipart/form-data' }
            }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-user-plan-details/?user_id=${userInfo.id}`, config2);
            if (response.status === 200) {
                setCurrentPlan(response.data.results);
                setLoading(false)
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
            setLoading(false);
        }
    }
    useEffect(() => {
        GetPlans();
        getCurrentPlan()
    }, []);
    useEffect(() => {
        if (reportCount) {
            getCustomPlan();
            setCouponCode("");
            setCouponCodeErr("");
            setopencupon(false);
            setshowapplybutton(true)
            setdiscountedPrice(null)
        }
    }, [reportCount]);
    const handlechange = (card) => {
        setBuyingCard(card);
        setReportCount(card.no_of_projects_allowed);
        setSelectedCard(card.id);
        if(card.id === 6 ){
            setTimeout(() => {
                setCouponCode("ITSERVE2025")
            }, 100);
        }
    };
    // const onCircleChange = (val) => {
    //     setReportCount(val);
    //     const matchedCard = [...plans]
    //         .filter(card => card.no_of_projects_allowed >= val)
    //         .sort((a, b) => a.no_of_projects_allowed - b.no_of_projects_allowed)[0];

    //     if (matchedCard) {
    //         setSelectedCard(matchedCard.id);
    //         setBuyingCard(matchedCard);

    //     } else {
    //         setSelectedCard(plans[plans.length - 1]?.id || null);
    //     }
    // };
    const onCircleChange = (val) => {
        console.log(val,'valu');
        
        setReportCount(val);
        setlable(val)
        if (val === 5) {
            setTimeout(() => {
                setCouponCode("ITSERVE2025")
            }, 100);
        }
        
        const matchedCard = plans.find(card => card.no_of_projects_allowed === val);
        
        if (matchedCard) {
            setSelectedCard(matchedCard.id);
            setBuyingCard(matchedCard);
        } else {
            setSelectedCard(null);
            setBuyingCard(null);
        }
        
    };

    const IsCustom = !plans?.some(plan => Number(plan.no_of_projects_allowed) === Number(reportCount));
    const features = [
        {
            icon: <IconBrain />,
            title: "AI Business Idea Validation",
            description: "Quickly test your startup idea against real-time market dynamics. Let our AI show you if your concept is fundable or fixable.",
            color: "#5a1bc2"
        },
        {
            icon: <IconFilePercent />,
            title: "Business Plan Generator",
            description: "Generate a strategic business plan with financial forecasting, competitor benchmarking, and go-to-market mapping - automatically.",
            color: "#1e88e5"
        },
        {
            icon: <IconBuilding />,
            title: "Executive Summary Generator",
            description: "Create investor-aligned summaries that capture the essence of your business in just a few paragraphs.",
            color: "#43a047"
        },
        {
            icon: <IconTargetArrow />,
            title: "AI Pitch Deck Generator",
            description: "From idea to investor deck in minutes. Get presentation-ready slides backed by storytelling and data logic.",
            color: "#fb8c00"
        },
        {
            icon: <IconBook />,
            title: "Market Analysis",
            description: "Map out your positioning with AI-powered marketing competitor analysis, customer insights, and lean business modeling.",
            color: "#8e24aa"
        },
        {
            icon: <IconCloudDown />,
            title: "Instant Downloads in PDF",
            description: "Your reports are pitch-ready and presentation-proof. Instantly download, share, or attach them in PDF format to investor presentations.",
            color: "#3949ab"
        },
        {
            icon: <IconDiamond />,
            title: "Zero Subscriptions, One-Time Pricing",
            description: "Get everything for one flat fee. No recurring costs, no tier traps, no distractions.",
            color: "#00897b"
        },
        {
            icon: <IconBolt />,
            title: "Fast, Friendly, Foolproof",
            description: "Answer simple prompts. Let AI build the logic. You get a smart strategy, without spreadsheets or formatting struggles.",
            color: "#f4511e"
        },
        {
            icon: <IconLock />,
            title: "Data Security Guaranteed",
            description: "Your inputs stay yours. All information is encrypted, private, and never shared. Built for trust and compliance.",
            color: "#546e7a"
        }
    ];
    const GetData = async () => {
        try {
            const response = await axios.get('/apiV1/get-profile/');
            if (response.status === 200) {
                console.log(response.data.message);
                setValue('email', response.data.message.email)
                setValue('mobileNumber', response.data.message.mobile)
                setValue('companyName', response.data.message?.company_name)
                setValue('fullName', response.data.message.fullname)
            }
        } catch (error) {
            console.error("Error fetching profile data:", error.response ? error.response.data : error.message);
        }
    };
    useEffect(() => {
        const handle = document.querySelector('circle[filter="url(#handleShadow)"]');
        if (handle) {
            handle.setAttribute('r', '12');
        }
    }, []);

    const circleCount = reportCount > 20 ? 1 : reportCount;
    return (
        <PageContainer title="SmartInvestorDeck | Create Business Ideas">
            <ScheduleDemo showBanner={true} />
            {(loading || zeroPlanLoading) && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100vw",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        zIndex: 9999,
                    }}
                >
                    <BeatLoader color=" #07659c" size={20} />
                </Box>
            )}
            <Grid container-fluid justifyContent="center" alignItems="center" >
                <Grid container spacing={4} justifyContent="center" alignItems="flex-start">
                    {/* Left: Text Section */}
                    <Grid item xs={12} md={6} lg={9}>
                        <Box sx={{ width: "100%" }}>
                            <Typography
                                variant="h3"
                                align="center"
                                sx={{
                                    fontWeight: 550,
                                    mb: 2,
                                    background: 'linear-gradient(180deg, var(--primary-black), var(--primary-red))',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                Unlock Your Complete Business Report!
                            </Typography>
                            <Typography variant="h6" align="center" color="grey">
                                Pay Once - No Recurring Fees.
                            </Typography>
                            <Typography variant="h6" align="center" color="grey">
                                Access your full business report and make unlimited updates or revisions anytime.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Right: Current Plan Card */}
                    {CurrentPlan?.length > 0 && CurrentPlan?.[0]?.is_free === false && (
                        <Grid item xs={12} md={4} lg={3}>
                            <Card
                                sx={{
                                    padding: 2,
                                    textAlign: 'center',
                                    boxShadow: 4,
                                    backgroundColor: "#F0F9FF",
                                    border: '2px solid #076599',
                                    borderRadius: "12px",
                                    transition: 'all 0.3s ease',
                                    transform: 'scale(1.03)',
                                    position: 'relative',
                                }}
                            >
                                {/* Badge */}
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: "-2px",
                                        backgroundColor: '#66a321',
                                        color: '#fff',
                                        padding: '4px 10px',
                                        borderRadius: '8px 0px 8px 0px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        boxShadow: 2,
                                    }}
                                >
                                    In Use
                                </Box>

                                {/* <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, mt: 1 }}>
                                    {CurrentPlan?.[0].plan_name}
                                </Typography> */}
                                {/* <Typography component="span" sx={{ color: 'gray',  }}>
                                    Last Purchased Ideas: {CurrentPlan?.[0]?.last_purchased_plan_ideas}
                                </Typography> */}
                                <Typography  sx={{ color: 'gray',mb:1 }}>
                                   Utilized Business Ideas: {CurrentPlan?.[0]?.total_projects_used}
                                </Typography>
                                {/* <Typography sx={{ color: 'gray', mb: 1 }}>
                                    Utilized Business Ideas:{' '}
                                    {CurrentPlan?.[0]?.is_free ? 0 : CurrentPlan?.[0]?.total_projects_used}
                                </Typography> */}

                                <Typography  sx={{ color: 'gray',mb:1}}>
                                   Remaining Business Ideas: {CurrentPlan?.[0]?.total_projects-CurrentPlan?.[0]?.total_projects_used}
                                </Typography>
                                <Typography
                                    sx={{
                                        color: '#014670',
                                        mb: 2,
                                        cursor: 'pointer',
                                        fontWeight:600,
                                        // textDecoration:"underline"
                                    }}
                                    onClick={()=>navigate('/plans/transactionhistory')} 
                                    >
                                   <span>🔗</span> View Transaction History
                                    </Typography>

                                {/* <Typography component="span" sx={{ color: 'gray', mb: 2 }}>
                                    Used business ideas: {CurrentPlan?.[0].total_projects_used}/{CurrentPlan?.[0].total_projects}
                                </Typography> */}
                               {CurrentPlan?.[0] && !CurrentPlan[0].is_free && CurrentPlan[0].start_date && (
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    Payment Date: {dayjs(CurrentPlan[0].start_date).format("MM-DD-YYYY")}
                                </Typography>
                                )}
                                {/* <Typography variant="h6" sx={{ mb: 1, mt: 1 }}>
                                    Amount : <span style={{ fontWeight: 600, fontSize: '26px', color: "#78a02f" }}> 
                                        ${CurrentPlan?.[0].total_amount}
                                    </span>
                                </Typography> */}
                            </Card>
                        </Grid>
                    )}
                </Grid>

                <Grid container spacing={4} justifyContent="center" alignItems="flex-start" sx={{ mt: 2 }}>
                    <Grid item xs={12} md={8} lg={9}>
                        <Grid container justifyContent="center">
                            {/* {CurrentPlan?.length > 0 && (
                                <Grid item xs={12} sm={10} md={10} lg={6} mb={3}>
                                    <Card
                                        sx={{
                                            padding: 2,
                                            textAlign: 'center',
                                            boxShadow: 4,
                                            backgroundColor: "#F0F9FF",
                                            border: '2px solid #076599',
                                            borderRadius: "12px",
                                            transition: 'all 0.3s ease',
                                            transform: 'scale(1.03)',
                                            position: 'relative', // Needed for absolute badge positioning
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: "-2px",
                                                backgroundColor: '#66a321',
                                                color: '#fff',
                                                padding: '4px 10px',
                                                borderRadius: '8px 0px 8px 0px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                boxShadow: 2,
                                            }}
                                        >
                                            Current Plan
                                        </Box>

                                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                            {CurrentPlan?.[0].plan_name}
                                        </Typography>
                                        <Typography component="span" sx={{ color: 'gray', mb: 1 }}>
                                            Remaining business ideas: {CurrentPlan?.[0].total_projects_used}/{CurrentPlan?.[0].total_projects}
                                        </Typography>
                                        <Typography variant="h6" sx={{ mb: 1, mt: 1 }}>
                                            Amount : <span style={{ fontWeight: 600, fontSize: '26px', color: "#78a02f" }}>
                                                ${CurrentPlan?.[0].total_amount}
                                            </span>
                                        </Typography>
                                    </Card>
                                </Grid>
                            )} */}

                            <Grid container spacing={2}>
                                {plans.map((card) => (
                                    <Grid item xs={12} sm={6} md={6} lg={4} key={card.id}>
                                        <Card
                                            onClick={() => handlechange(card)}
                                            sx={{
                                                position: "relative",
                                                overflow: "visible",
                                                paddingTop: "32px",
                                                padding: 2,
                                                textAlign: 'center',
                                                boxShadow: selectedCard === card.id ? 4 : 0,
                                                border: selectedCard === card.id ? card.id === 6 ?'2px solid #119905ff' : '2px solid #c53131' : '1px solid #3d3b3b17',
                                                borderRadius: "12px",
                                                cursor: 'pointer',
                                                backgroundColor: card.id ===6 && selectedCard === card.id ?'#c8f0c33d':''
                                            }}
                                        >

                                            {/* 🎉 OFFER BADGE — Only for card.id === 6 */}

                                            {card.id === 6 && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: -18,
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        background: "linear-gradient(90deg, #007c4f, #00a65a, #00d678, #007c4f)",
                                                        backgroundSize: "300% 300%",
                                                        animation: "darkGradient 5s ease infinite, darkGlow 3s ease-in-out infinite",
                                                        color: "#ffffff",
                                                        padding: "6px 28px",
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        borderRadius: "999px",
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                                                        whiteSpace: "nowrap",
                                                        zIndex: 20,
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.5px",

                                                        // Darker smooth gradient animation
                                                        "@keyframes darkGradient": {
                                                            "0%": { backgroundPosition: "0% 50%" },
                                                            "50%": { backgroundPosition: "100% 50%" },
                                                            "100%": { backgroundPosition: "0% 50%" },
                                                        },

                                                        // Professional darker glow
                                                        "@keyframes darkGlow": {
                                                            "0%": { boxShadow: "0 4px 14px rgba(0, 80, 40, 0.3)" },
                                                            "50%": { boxShadow: "0 4px 20px rgba(0, 150, 80, 0.55)" },
                                                            "100%": { boxShadow: "0 4px 14px rgba(0, 80, 40, 0.3)" },
                                                        },
                                                    }}
                                                >
                                                    ITSERVE OFFER
                                                </Box>
                                            )}





                                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                                {card.name}
                                            </Typography>

                                            <Typography component="span" sx={{ color: 'gray', mb: 1 }}>
                                                No of Business Ideas: {card.no_of_projects_allowed}
                                            </Typography>

                                            <Typography variant="h5" color="#c53131" sx={{ mb: 1, fontWeight: 600, fontSize: '26px', mt: 1 }}>
                                                {card.currency === "Rupees" ? (<>₹{card.price}</>) : (<>${card.price}</>)}
                                            </Typography>

                                            {card.tag && (
                                                <Box
                                                    sx={{
                                                        backgroundColor: "#E0E7FF",
                                                        borderRadius: "10px",
                                                        padding: "3px 10px",
                                                        fontSize: "12px",
                                                        display: "inline-block",
                                                        marginTop: "4px",
                                                        color: "#3730A3",
                                                    }}
                                                >
                                                    {card.tag}
                                                </Box>
                                            )}

                                            <Typography variant="body2" color="textSecondary" mt={1}>
                                                {card.description}
                                            </Typography>

                                        </Card>
                                    </Grid>
                                ))}

                                {/* ENTERPRISE CARD SECTION */}
                                <Grid container spacing={5} sx={{ padding: 2 }}>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: "#fff8f7",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "12px",
                                                p: 2,
                                                width: "100%",
                                                maxWidth: "800px",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                fontFamily: "sans-serif",
                                            }}
                                        >
                                            <Box>
                                                <Typography variant="h6" fontWeight="bold" color="#1d2939">
                                                    Enterprise
                                                </Typography>
                                                <Typography variant="body2" color="#667085" sx={{ mt: 2 }}>
                                                    Personalized Business Ideas Designed for You
                                                </Typography>
                                            </Box>
                                            <Button onClick={() => { setContactpopup(true); GetData() }}>
                                                Contact Us
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/* AVAILABLE FEATURES */}
                                <Box sx={{ py: 5, px: 2 }}>
                                    <Typography variant="h6" fontWeight={600} mb={1}>
                                        ⚡Available Features
                                    </Typography>
                                    <Grid container spacing={3} justifyContent="center">
                                        {features.map((item, idx) => (
                                            <Grid item xs={12} sm={6} md={6} lg={4} key={idx}>
                                                <Card
                                                    sx={{
                                                        p: 2,
                                                        borderRadius: 3,
                                                        boxShadow: 0,
                                                        border: "1px solid #e1e1e1",
                                                        height: '100%',
                                                    }}
                                                >
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                        <Box sx={{ fontSize: '28px', fontWeight: 600, color: item.color }}>
                                                            {item.icon}
                                                        </Box>
                                                        <Typography sx={{ fontSize: "16px" }} fontWeight={600}>
                                                            {item.title}
                                                        </Typography>
                                                    </Box>

                                                    <Typography variant="body2" color="text.secondary">
                                                        {item.description}
                                                    </Typography>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>

                            </Grid>


                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Box p={2} sx={{ border: "1px solid #eee", borderRadius: "12px", boxShadow: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: 600, textAlign: "center", mb: 1 }}>Flexible Pay</Typography>
                            <Typography mb={2} sx={{ textAlign: "center", fontSize: 14 }}>Select the number of report credits you need</Typography>
                            <Box
                                sx={{
                                    position: 'relative',
                                    width: 200,
                                    height: 200,
                                    mx: 'auto', // <== Center the circle horizontally
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 0,
                                }}
                            >
                                <div style={{ transform: "rotate(-180deg)" }}>
                                    <CircularSlider
                                        size={200}
                                        trackWidth={12}
                                        minValue={1}
                                        maxValue={20}
                                        startAngle={0}
                                        endAngle={360}
                                        radius={25}
                                        handle1={{
                                            value: circleCount,
                                            onChange: (val) => onCircleChange(Math.round(val)),
                                        }}
                                        arcColor="#c53131"
                                        arcBackgroundColor="#fbedec"
                                    />
                                </div>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography variant="h5" fontWeight={600}>
                                        {reportCount}
                                    </Typography>
                                    <Typography variant="caption">Reports</Typography>
                                </Box>
                            </Box>

                                        <Box
                                            sx={{
                                                p: 2,
                                                borderRadius: 2,
                                                backgroundColor: "#fafafa",
                                                border: "1px solid #e0e0e0",
                                                width: "100%",
                                                mt:0
                                            }}
                                        >
                                            {/* Title */}
                                            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                <LocalOfferOutlined sx={{ fontSize: 20, color: "#ff4d4f", mr: 1 }} />
                                                <Typography fontWeight="bold" sx={{ fontSize: "0.95rem" }}>
                                                    Have a coupon code?
                                                </Typography>
                                            </Box>
                                           {discountedPrice === null ?  <Box sx={{ display: "flex", gap: 1 }}>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter code"
                                                    size="small"
                                                    value={couponCode}
                                                    onChange={(e) => {setCouponCode(e.target.value); setCouponCodeErr(""); setshowapplybutton(true);}}
                                                />
                                                <Button variant="contained" onClick={()=>{handleApplyCoupon()}}
                                                >
                                                    Apply
                                                </Button>
                                            </Box> : <Alert icon={<IconCheck fontSize="inherit" />} severity="success" onClose={()=>{{setopencupon(false); setCouponCode(""); setCouponCodeErr("");setshowapplybutton(true);getCustomPlan();setdiscountedPrice(null);setisZeroPlan(false)}}}>{couponCode}
                                            {/* <Typography sx={{fontSize:"13px"}}>Saved</Typography> */}
                                            </Alert>}
                                             {couponCodeErr && <Typography sx={{ color: messageColor, fontSize: "0.8rem" }}>{couponCodeErr}</Typography>}
                                        </Box>
                            {CustomPlanError ? <Typography sx={{ color: "#f50000", fontSize: "0.9rem" }}>{CustomPlanError}</Typography>
                                : <>
                                    <Box sx={{ mx: 2, my: 2 }}>
                                        <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
                                            Total Cost
                                        </Typography>
                                        {discountedPrice === null ?
                                            <>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                    <Typography>Price</Typography>
                                                    <Typography>${customPlan?.base_price}</Typography>
                                                </Box>
                                            </> :
                                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                <Typography>Price</Typography>
                                                <Typography>${discountedPrice?.original_amount}</Typography>
                                            </Box>}
                                        {discountedPrice === null ?
                                            <>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                    <Typography>Tax ({(customPlan?.total_tax_percentage)}%)</Typography>
                                                    <Typography>${(customPlan?.tax_amount)}</Typography>
                                                </Box>
                                            </> :
                                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                                <Typography>Tax ({(discountedPrice?.total_tax_rate)}%)</Typography>
                                                <Typography>${(discountedPrice?.tax_amount)}</Typography>
                                            </Box>}
                                        
                                        {discountedPrice !== null ?
                                            <>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 ,color:"#4caf50"}}>
                                                    <Typography>Discount ({(discountedPrice?.discount_percentage)}%)</Typography>
                                                    <Typography>${(discountedPrice?.discount_amount)}</Typography>
                                                </Box>
                                            </> :""}
                                        {/* <Typography sx={{ color: "#f50000",cursor: "pointer" }} onClick={() => {setopencupon(true)}}>Apply coupon code</Typography>
                                        {opencupon && (
                                            <Box sx={{ mt: 1,gap:2 }}>
                                                <TextField
                                                    fullWidth
                                                    label="Coupon Code"
                                                    size="small"
                                                    value={couponCode}
                                                    onChange={(e) => {setCouponCode(e.target.value); setCouponCodeErr(""); setshowapplybutton(true);}}
                                                />
                                                {couponCodeErr && <Typography sx={{ color: messageColor, fontSize: "0.8rem" }}>{couponCodeErr}</Typography>}
                                               {showapplybutton && <Button variant="outlined" sx={{ mt: 1 }} onClick={()=>{handleApplyCoupon()}}>
                                                    Apply
                                                </Button>}
                                                <Button variant="outlined" sx={{ mt: 1,ml:1 }} onClick={()=>{setopencupon(false); setCouponCode(""); setCouponCodeErr("");setshowapplybutton(true);getCustomPlan();setdiscountedPrice(null);}}>
                                                    Remove
                                                </Button>
                                            </Box>
                                        )} */}
                                        <Divider sx={{ my: 1 }} />

                                        
                                        {discountedPrice === null ?
                                            <>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                            <Typography fontWeight="bold">Total</Typography>
                                            <Typography fontWeight="bold">
                                                ${(customPlan?.total_price)}
                                            </Typography>
                                        </Box>
                                            </> :<>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                            <Typography fontWeight="bold">Total</Typography>
                                            <Typography fontWeight="bold">
                                                ${(discountedPrice?.final_amount_to_pay)}
                                            </Typography>
                                            
                                        </Box>
                                        <Typography sx={{ color: "#4caf50", fontWeight: "bold" ,textAlign:"end",mb:0}}>
                                                You saved ${(discountedPrice?.discount_amount)}
                                            </Typography></>}
                                    </Box>

                                </>
                            }
                            {reportCount >= 20 ? <Alert severity="info" sx={{ mt: 2 }}>
                                Need more? For discounted bulk pricing and unlimited reports <span style={{ color: "#4f46e5", fontWeight: 600, textDecoration: "underline", cursor: "pointer" }} onClick={() => {setContactpopup(true);GetData()}}> Contact Us</span>
                            </Alert> : null}
                            <Box display="flex" justifyContent="center" mt={2}>
                                <Button
                                    variant="contained"
                                    // className="button2"
                                    sx={{ marginTop: 1 }}
                                    disabled={CustomPlanError}
                                     onClick={() => { isZeroPlan ? setconfirmPurchasePopup(true) :navigate(`/plans/billing?${currentPlanId ? `currentplanid=${currentPlanId}&` : ''}selectedplanid=${buyingCard?.id}&planName=${reportCount}&is_custom=${IsCustom}&ReportCount=${reportCount}&${couponCode ? `couponCode=${couponCode}` : ''}`)}}
                                    // onClick={()=>setAlretPopUp(true)}
                                >
                                    Purchase {reportCount} Business Idea{reportCount > 1 ? 's' : ''} Now <IconArrowRight />
                                </Button>
                            </Box>

                        </Box>
                    </Grid>
                </Grid>

            </Grid>
            <Dialog open={Contactpopup} maxWidth="md" fullWidth>
                <DialogTitle>
                    <Box sx={{display:"flex",justifyContent:"space-between"}}><Typography sx={{fontSize:"1.2rem",fontWeight:"600"}}>Contact Us for Bulk Pricing</Typography><IconButton onClick={()=>{setContactpopup(false);reset()}}><IconX/></IconButton></Box></DialogTitle>
                <Divider/>
                <DialogContent sx={{p:5}}>
                    <form onSubmit={handleSubmit(onSubmit)} id="contact-form">
                        <Grid container spacing={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth margin="dense">
                                        <Typography variant="body2" gutterBottom>
                                            Full Name <span style={{ color: "red", fontWeight: 600 }}>*</span>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            {...register("fullName", {
                                                required: "Full Name is required",
                                                pattern: {
                                                    value: /^[A-Za-z][A-Za-z ]*$/,
                                                    message: "Must start with a letter and contain only letters and spaces",
                                                },
                                            })}
                                            onKeyUp={()=>trigger("fullName")}
                                            error={!!errors.fullName}
                                            helperText={errors.fullName?.message}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth margin="dense">
                                        <Typography variant="body2" gutterBottom>
                                            Company Name <span style={{ color: "red", fontWeight: 600 }}>*</span>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            {...register("companyName", {
                                                required: "Company Name is required",
                                                pattern: {
                                                    value: /^[A-Za-z][A-Za-z ]*$/,
                                                    message: "Must start with a letter and contain only letters and spaces",
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: "Max 50 characters allowed",
                                                },
                                            })}
                                            onKeyUp={()=>trigger("companyName")}
                                            error={!!errors.companyName}
                                            helperText={errors.companyName?.message}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth margin="dense">
                                        <Typography variant="body2" gutterBottom>
                                            Mobile Number <span style={{ color: "red", fontWeight: 600 }}>*</span>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            inputProps={{
                                                inputMode: "tel",
                                                maxLength: 20,
                                            }}
                                            {...register("mobileNumber", {
                                                required: "Mobile Number is required",
                                                pattern: {
                                                value: /^(?! )[+0-9()\-\s]{8,20}$/, 
                                                message: "Enter a valid mobile number (no space at start)",
                                                },
                                                minLength: {
                                                value: 8,
                                                message: "Mobile number must be at least 8 characters",
                                                },
                                                maxLength: {
                                                value: 20,
                                                message: "Mobile number must not exceed 20 characters",
                                                },
                                            })}
                                            onKeyUp={() => trigger("mobileNumber")}
                                            error={!!errors.mobileNumber}
                                            helperText={errors.mobileNumber?.message}
                                        />

                                    </FormControl>
                                 </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth margin="dense">
                                        <Typography variant="body2" gutterBottom>
                                            Email <span style={{ color: "red", fontWeight: 600 }}>*</span>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            {...register("email", {
                                                required: "Email is required",
                                                pattern: {
                                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                    message: "Enter a valid email address",
                                                },
                                            })}
                                            onKeyUp={()=>trigger("email")}
                                            error={!!errors.email}
                                            helperText={errors.email?.message}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth margin="dense">
                                        <Typography variant="body2" gutterBottom>
                                            No. of Business Ideas <span style={{ color: "red", fontWeight: 600 }}>*</span>
                                        </Typography>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            inputProps={{ min: 21}}
                                            {...register("numBusinessIdeas", {
                                                required: "This field is required",
                                                min: {
                                                    value: 21,
                                                    message: "No. of Business Ideas must be greater than 20",
                                                },
                                                valueAsNumber: true,
                                            })}
                                            onKeyUp={()=>trigger("numBusinessIdeas")}
                                            error={!!errors.numBusinessIdeas}
                                            helperText={errors.numBusinessIdeas?.message}
                                        />
                                    </FormControl>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <FormControl fullWidth margin="dense">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...register("privacyPolicy", {
                                                        required: "You must agree to the Privacy Policy",
                                                    })}
                                                />
                                            }
                                            label="I agree to the Privacy Policy *"
                                        />
                                        {errors.privacyPolicy && (
                                            <Typography sx={{ color: "red", fontSize: "13px" }}>
                                                {errors.privacyPolicy.message}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Grid> */}
                                </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                                    <Button variant="outlined" onClick={() => {setContactpopup(false);reset()}}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained" type="submit" color="primary" className='button2'>
                                        Submit
                                    </Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </form>

                </DialogContent>
            </Dialog>
             <Dialog open={successpopup} fullWidth maxWidth="md"sx={{maxWidth: "700px", margin: "auto" }}>
          <DialogTitle sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#0e860e",
                  padding: 3,
                  "&:hover": { backgroundColor: "#0e860e" }
                }}
              >
                <IconCheck color="#fff" size={30} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
             Your request was submitted successfully. We will get back to you shortly.
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { setsuccesspopup(false); }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
            {/* <Dialog open={AlretPopUp} fullWidth>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
                            Confirm Payment
                        </Typography>
                        <IconButton onClick={() => setAlretPopUp(false)}>
                            <IconX />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <Divider />
                <DialogContent sx={{ textAlign: "center", mt: 1 }}>
                    <Box
                        sx={{
                            width: 60,
                            height: 60,
                            backgroundColor: "#fdecea",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            margin: "0 auto 16px auto",
                        }}
                    >
                        <IconAlertTriangle size={32} color="#e57373" />
                    </Box>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Proceed to Payment
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Are you sure you want to proceed with the payment
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{ width: 120 }}
                        onClick={() => setAlretPopUp(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        sx={{ width: 120, backgroundColor: "#c63037" }}
                        onClick={() =>navigate( `/plans/billing?${currentPlanId ? `currentplanid=${currentPlanId}&` : ""}selectedplanid=${buyingCard?.id}&planName=${reportCount}&is_custom=${IsCustom}&ReportCount=${reportCount}`)}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog> */}

            <Dialog open={confirmPurchasePopup} fullWidth>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
                            Confirm Purchase
                        </Typography>
                        <IconButton onClick={() => setconfirmPurchasePopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ textAlign: "center", mt: 1 }}>
                    <Box
                        sx={{
                            width: 60,
                            height: 60,
                            backgroundColor: "#ecfdea",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            margin: "0 auto 16px auto",
                        }}
                    >
                        <IconHeartHandshake size={32} color="#189638" />
                    </Box>

                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Purchase Plan
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                        Are you sure you want to purchase this plan using the applied coupon?
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{ width: 120 }}
                        onClick={() => setconfirmPurchasePopup(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        sx={{ width: 120, backgroundColor: "#c63037" }}
                        onClick={handleZeroPlan}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Cupon success modal */}

            <Dialog open={successPopup} fullWidth>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
                            Success
                        </Typography>
                        <IconButton onClick={() => setSuccessPopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <Divider />

                <DialogContent sx={{ textAlign: "center", mt: 1 }}>
                    <Box
                        sx={{
                            width: 60,
                            height: 60,
                            backgroundColor: "#e8f5e9",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            margin: "0 auto 16px auto",
                        }}
                    >
                        <IconCheck size={32} color="#2e7d32" />
                    </Box>

                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Congratulations!
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                        Your coupon code has been successfully applied. You’re one step ahead.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="contained"
                        sx={{
                            width: 140,
                            backgroundColor: "#2e7d32",
                            "&:hover": { backgroundColor: "#1b5e20" },
                        }}
                        onClick={() => setSuccessPopup(false)}
                    >
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>


            {/* Zero Plan Success Modal */}
            <Dialog open={zeroPlanSuccess} fullWidth maxWidth="md" sx={{ maxWidth: "700px", margin: "auto" }}>
                <DialogTitle sx={{ fontWeight: "bold" }}>
                    Success
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                        <IconButton
                            disableRipple
                            sx={{
                                backgroundColor: "#0e860e",
                                padding: 3,
                                "&:hover": { backgroundColor: "#0e860e" }
                            }}
                        >
                            <IconCheck color="#fff" size={30} />
                        </IconButton>
                    </Box>
                    <DialogContentText sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
                        Your plan has been successfully activated!
                    </DialogContentText>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        onClick={() => { setZeroPlanSuccess(false); navigate('/dashboard'); }}
                        className="button2"
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Zero Plan Error Modal */}
            <Dialog open={zeroPlanError} fullWidth maxWidth="md" sx={{ maxWidth: "700px", margin: "auto" }}>
                <DialogTitle sx={{ fontWeight: "bold", color: "#d32f2f" }}>
                    Error
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                        <IconButton
                            disableRipple
                            sx={{
                                backgroundColor: "#d32f2f",
                                padding: 3,
                                "&:hover": { backgroundColor: "#d32f2f" }
                            }}
                        >
                            <IconX color="#fff" size={30} />
                        </IconButton>
                    </Box>
                    <DialogContentText sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
                        {zeroPlanErrorMessage}
                    </DialogContentText>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        onClick={() => { setZeroPlanError(false); setZeroPlanErrorMessage(""); }}
                        className="button2"
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

        </PageContainer >
    )
}

export default NewPricing
